export const rIC = (fn: () => void) => {
  return window.requestIdleCallback
    ? window.requestIdleCallback(fn)
    : window.setTimeout(fn, 0)
}
